import { render, staticRenderFns } from "./brush-list.vue?vue&type=template&id=fe5750ec&scoped=true&"
import script from "./brush-list.vue?vue&type=script&lang=js&"
export * from "./brush-list.vue?vue&type=script&lang=js&"
import style0 from "./brush-list.vue?vue&type=style&index=0&id=fe5750ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5750ec",
  null
  
)

export default component.exports